import { chain } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { QueuedItemStatus } from '../../../graphql/projects/models/QueuedItemStatus';

export type ProgressDateSelectBag = ReturnType<typeof useProgressDateSelect>;

export function useProgressDateSelect(project: ProjectGq) {
  // Find relevant dates
  const relevantDates: string[] = useMemo(
    () =>
      chain(project?.projectSerpTrackingRequests)
        .filter((t) => t.status === QueuedItemStatus.SUCCEEDED)
        .orderBy((t) => t.scheduledTime)
        .map((t) => t.scheduledTime)
        .value(),
    [project?.projectSerpTrackingRequests]
  );

  // Date selection
  const initialMinDate = relevantDates?.length ? relevantDates[0] : undefined;
  const [dateMin, setDateMin] = useState<string>(initialMinDate);

  const initialMaxDate = relevantDates?.length
    ? relevantDates[relevantDates.length - 1]
    : undefined;
  const [dateMax, setDateMax] = useState<string>(initialMaxDate);

  // Reset dates
  const resetDates = useCallback(() => {
    setDateMin(initialMinDate);
    setDateMax(initialMaxDate);
  }, [initialMinDate, initialMaxDate]);

  return {
    dateMin,
    setDateMin,
    dateMax,
    setDateMax,
    resetDates,
    relevantDates,
  };
}
